@if (cellStyle == 'default') {
  <div class="dropdown-search-multiple-container">
    <div #display (click)="focusSearch()" [style.width]="width + 'px'" style="cursor: pointer; overflow: hidden; padding: 0; height: 24px; line-height: 24px; border: 1px solid #A6A6A6; box-sizing: border-box;"
      hoverPanel [hoverPanelTemplate]="panel" [hoverPanelZIndex]="hoverPanelZIndex" (hoverPanelClose)="onHoverPanelClose()">
      <div #displayContainer style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;line-height: inherit;" tooltip [tooltipTitle]="displayValue" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6" >
        <span class="displayValue" style="padding: 0 5px;" (click)="$event.stopPropagation(); display.click();">{{displayValue | decodeHtml}}</span>
      </div>
    </div>
  </div>
}

@if (cellStyle == 'labels') {
  <div class="dropdown-search-multiple-container no-background" [class]="{'overflowTextVisible': hiddenLabelCount > 0, 'read-only': !canEdit}">
    @if (canEdit) {
      <div #display [style.width]="width + 'px'" style="cursor: pointer; overflow: hidden; padding: 0 5px 3px 5px; margin-left: -5px; border: 1px solid #A6A6A6; box-sizing: border-box; line-height: 24px; max-height: 27px;"
        hoverPanel [hoverPanelTemplate]="panel" [hoverPanelZIndex]="hoverPanelZIndex" (hoverPanelClose)="onHoverPanelClose()">
        <div #displayContainer style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap" (click)="$event.stopPropagation(); display.click();">
          @if ((!values || values?.length == 0) && showNone) {
            <span class="displayValue" style="padding: 0 5px;">{{noneDisplayText}}</span>
          }
          @if (values && values?.length > 0) {
            <span class="label container cell">
              @for (item of values; track item) {
                <span class="label button cell" tooltip [tooltipTitle]="item.name" [tooltipRequiresTruncation]="true">{{item.name}}</span>
              }
            </span>
          }
          <i class="pi pi-chevron-down clickable"></i>
        </div>
      </div>
    }
    @if (canEdit && (hiddenLabelCount > 0)) {
      <span class="overflowText irb-blue clickable" hoverPanel [hoverPanelTemplate]="hiddenLabelPanel" [hoverPanelZIndex]="hoverPanelZIndex" [hoverPanelHeight]="hiddenLabelHeight" #display>
        <span #displayContainer title="Show hidden">+{{hiddenLabelCount}}</span>
      </span>
    }
    @if (!canEdit) {
      <div #displayContainer style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
        @if ((!values || values?.length == 0) && showNone) {
          <span class="displayValue" style="padding: 0 5px;">{{noneDisplayText}}</span>
        }
        @if (values && values?.length > 0) {
          <span class="label container cell">
            @for (item of values; track item) {
              <span class="label button cell">
                @if (item.name) {
                  <span tooltip [tooltipTitle]="item.name" [tooltipRequiresTruncation]="true">{{item.name}}</span>
                }
              </span>
            }
          </span>
        }
        @if (hiddenLabelCount > 0) {
          <div class="overflowText read-only irb-blue clickable" hoverPanel [hoverPanelTemplate]="hiddenLabelPanel" [hoverPanelZIndex]="hoverPanelZIndex" [hoverPanelHeight]="hiddenLabelHeight" #display>
            <span #displayContainer title="Show hidden">+{{hiddenLabelCount}}</span>
          </div>
        }
      </div>
    }
  </div>
}

@if (cellStyle == 'classes') {
  <div class="dropdown-search-multiple-container no-background" [class]="{'overflowTextVisible': hiddenLabelCount > 0, 'read-only': !canEdit}">
    @if (!canEdit) {
      <div #displayContainer style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
        @if ((!values || values?.length == 0) && showNone) {
          <span class="displayValue" style="padding: 0 5px;">{{noneDisplayText}}</span>
        }
        @if (values && values?.length == 1) {
          <span class="label container cell">
            @for (item of values; track item) {
              <span class="label button cell">
                @if (item.name) {
                  <span tooltip [tooltipTitle]="item.name" [tooltipRequiresTruncation]="true">{{item.name}}</span>
                }
                <div style="display: flex; flex-direction: row;">
                  <span style="overflow: hidden; text-overflow: ellipsis;">
                    @if (item.names) {
                      <span tooltip [tooltipTitle]="item.names[0]" [tooltipRequiresTruncation]="true">{{item.names[0]}}</span>
                    }
                  </span>
                </div>
              </span>
            }
          </span>
        }
        @if (values && values?.length > 1) {
          <div title="Show {{hiddenLabelDescription}}" calltoaction [calltoactionTemplate]="hiddenLabelPanelB" calltoactionPosition="right" calltoactionMaxWidth="max-content">
            <div class="irb-blue clickable underline">{{values.length}} {{hiddenLabelDescription}}</div>
            <i class="pi pi-ellipsis-h clickable"></i>
          </div>
        }
      </div>
    }
  </div>
}

<ng-template #panel>
  <div [style]="{height: (showSearchResults) ? '261px' : '34px'}">
    <div class="ddsmHoverPanel shadow" [style.width.px]="hoverPanelWidth" #panel>
      <div style="padding: 5px">
        <input #input pInputText [formControl]="inputControl" (keyup)="setSearchResultVisibility()" (click)="unFocusGrid()" (keydown.tab)="focusGrid()" [style.width]="'100%'"
          autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="true" spellcheck="false" type="text" [placeholder]="placeholder"/>
        <span class="material-icons close_icon dd-search-fa-times" (click)="clearText()">clear</span>
      </div>
      @if (showSearchResults) {
        <div>
            <div [style]="{'display': (noOptionsTemplate && !searchString && data?.length == 0) ? 'block' : 'none'}" style="padding: 50px 0px; text-align: center; height: 181px; border-top: 1px solid #CCC;
    border-bottom: 1px solid #CCC;"><ng-container *ngTemplateOutlet="noOptionsTemplate"></ng-container></div>
            <div [style]="{'display': (!noOptionsTemplate || (noOptionsTemplate && (searchString || data?.length > 0))) ? 'block' : 'none'}">
              <ag-grid-angular
                style="width: 100%; height: 181px;"
                #agGrid
                class="irb-dropdown-search-multiple custom-dropdown-class"
                [suppressMovableColumns]="gridOptions.suppressMovableColumns"
                [suppressHorizontalScroll]="true"
                [suppressContextMenu]="true"
                [columnDefs]="gridOptions.columnDefs"
                [components]="frameworkComponents"
                (gridReady)="onGridReady($event)"
                [rowHeight]=30
                [headerHeight]="0"
                [overlayLoadingTemplate]="gridOptions.overlayLoadingTemplate"
                [overlayNoRowsTemplate]="gridOptions.overlayNoRowsTemplate"
                [rowSelection]="gridOptions.rowSelection"
                [rowClassRules]="gridOptions.rowClassRules"
                [suppressRowClickSelection]="true"
                (rowClicked)="onRowClicked($event)"
                >
              </ag-grid-angular></div>
              <div style="padding: 10px">
                @if (cellStyle == 'default') {
                  <div class="buttonSetDSM">
                    <ng-content select="[buttons]"></ng-content>
                    <button class="btn-medium-secondary" (click)="clear()" [disabled]="nothingSelected">Clear</button>
                    @if (showApplyButton) {
                      <button class="btn-medium-primary" (click)="apply(); fireApplySelection(); hide();" [disabled]="!hasChange()">Apply</button>
                    }
                  </div>
                }
                @if (cellStyle == 'labels') {
                  <div style="text-align: right;">
                    <ng-content select="[buttons]"></ng-content>
                    <button class="btn-medium-secondary" (click)="hide()">Cancel</button>
                    @if (showApplyButton) {
                      <button class="btn-medium-primary" (click)="apply(); fireApplySelection(); hide();" [disabled]="!hasChange()">Apply</button>
                    }
                  </div>
                }
              </div>
              @if (showAddNewButton) {
                <div class="ddsm-add-new-button">
                  <button class='btn-medium-secondary' (click)="addNewItemClick()">{{addNewItem.button}}</button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template #hiddenLabelPanel>
      <div class="ddsmHoverPanel shadow" style="width: 340px; margin-top: 8px;" #panel>
        <div style="padding: 10px 10px 0 10px">
          <span class="bold" style="max-width: 240px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; line-height: 18px;">{{hiddenLabelPanelTitle}}</span>
          <i class="material-icons right clear clickable" style="font-size: 18px !important;" title="Close" (click)="hide()">clear</i>
        </div>
        <div style="padding: 10px; overflow-y: auto; max-height: 220px;">
          <div class="label container cell">
            @for (item of values; track item) {
              <span class="label button cell max">
                @if (item.name) {
                  <span tooltip [tooltipTitle]="item.name" [tooltipRequiresTruncation]="true">{{item.name}}</span>
                }
                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                  <span style="overflow: hidden; text-overflow: ellipsis;">
                    @if (item.names) {
                      <span tooltip [tooltipTitle]="item.names[0]" [tooltipRequiresTruncation]="true">{{item.names[0]}}</span>
                    }
                  </span>
                  @if (item.names) {
                    <span style="margin: 2px 0 2px 6px; padding: 2px 0 2px 4px; line-height: 11px; font-size: 12px; border-left: 1px solid #999;">{{item.names[1]}}</span>
                  }
                </div>
              </span>
            }
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #hiddenLabelPanelB>
      <div #panel>
        <div class="hblock" style="font-size: 11px; color: #666; max-width: 240px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; line-height: 18px;">{{hiddenLabelPanelTitle}}</div>
        <div style="overflow-y: auto; max-height: 220px;">
          @for (item of values; track item) {
            <div class="label cell max" style="line-height: 24px; border-bottom: 1px solid #CCC; white-space: nowrap; margin: 2px 0 1px 0;">
              @if (item.name) {
                <span tooltip [tooltipTitle]="item.name" [tooltipRequiresTruncation]="true">{{item.name}}</span>
              }
              @if (item.names) {
                <div>
                  <span>{{item.names[0]}}</span>&nbsp;|&nbsp;
                  @if (item.names) {
                    <span>{{item.names[1]}}</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </ng-template>
